<script setup lang="ts">
import { useCreateReturnAdRequest } from '@/api'
import HeaderComponent from '@/components/Navigation/HeaderComponent.vue'
import ReturnAdForm from '@/components/ReturnAdForm/ReturnAdForm.vue'
import ReturnAdPreview from '@/components/ReturnAdPreview/ReturnAdPreview.vue'
import { notification } from '@/lib/helpers'
import { useBackToPreviousPage } from '@/lib/hooks/back-to-previous-page.hooks'
import { usePreviewData } from '@/lib/hooks/provider.hooks'
import type { ReturnAdFormType } from '@/lib/types/return-ad.types'
import { useUserStore } from '@/stores/user'
import { BoxComponent, FlexComponent, LoadingComponent } from '@/ui-library'

usePreviewData()
const userStore = useUserStore()
const { createAd, isLoading, error } = useCreateReturnAdRequest()

const handleBack = useBackToPreviousPage({ name: 'returnAds' })

const onReturnAdCreate = async (data: ReturnAdFormType) => {
  await createAd(data)
  if (!error.value) {
    await handleBack()
    notification.success('The return ad was created successfully')
  }
}
</script>

<template>
  <HeaderComponent />
  <LoadingComponent v-if="userStore.isLoading" :size="64" :is-full-size="true" />
  <template v-if="userStore.user">
    <FlexComponent justify="space-between" class="wrapper" :gap="40">
      <BoxComponent w="50%">
        <ReturnAdForm
          :is-loading="isLoading"
          :default-advertiser-group-id="userStore.user.storeGroupId"
          @handle-submit="onReturnAdCreate"
          @handle-back="handleBack"
        />
      </BoxComponent>
      <BoxComponent w="50%">
        <ReturnAdPreview />
      </BoxComponent>
    </FlexComponent>
  </template>
</template>

<style lang="scss" scoped>
.wrapper {
  max-width: 1320px;
  margin: 0 auto;
  padding: 40px 20px;
}
</style>
